import { action, observable, computed } from 'mobx';
import { uniqueId } from 'lodash';
import File from './file';

export default class Files {
  @observable fileList = [];

  constructor(settingsStore, request, data) {
    this.settingsStore = settingsStore;
    this.request = request;
    this.data = data;
  }

  @action
  uploadFile = ({ file, onSuccess, onError }) => {
    const id = uniqueId();
    this.addFile(file, id);
    const f = this.getFile(id);
    f.upload(onSuccess, onError);
  };

  @action
  addFile = (file, id) => {
    this.fileList.push(new File(this.settingsStore, this.request, file, id));
  };

  @action
  removeFile = ({ id }) => {
    this.fileList = this.fileList.filter(f => f.id !== id);
  };

  @action getFile = fid => this.fileList.find(f => f.id === fid);

  @computed
  get isUploading() {
    return this.fileList.some(f => f.status === 'uploading');
  }
}



// WEBPACK FOOTER //
// ./src/stores/files.js